import { DatePipe } from "@angular/common";
import { Component, computed, input } from "@angular/core";
import { PeriodDefinitionType } from "@models/map/market-filter.model";
import { ThousandizePipe } from "ev-core";
import { StatisticsLine } from "src/models/estate/IResidenceSaleInArea";
import { TimePeriodFilterModel } from "../../../estate-filter/search-filter-time-period/search-filter-time-period.model";
import { SearchViewOptionsFilterModel } from "../../../estate-filter/search-filter-view-options/search-filter-view-options.model";
import { StatisticsPriceassumptionComponent } from "../statistics-priceassumption/statistics-priceassumption.component";
import { StatisticsSoldComponent } from "../statistics-sold/statistics-sold.component";
import { MarketStatisticsHelperComponent } from "../../../estate-filter/search-filter-view-options/market-statistics-helper/market-statistics-helper.component";
import { EvTooltipModule } from "ev-tooltip";
import { ClickOutsideDirective } from "ev-directives";

@Component({
    selector: "market-price-statistics-header",
    imports: [
        DatePipe,
        ThousandizePipe,
        StatisticsSoldComponent,
        StatisticsPriceassumptionComponent,
        MarketStatisticsHelperComponent,
        EvTooltipModule,
        ClickOutsideDirective
    ],
    templateUrl: "./market-price-statistics-header.component.html",
    styleUrl: "./market-price-statistics-header.component.scss",
})
export class MarketPriceStatisticsHeaderComponent {
    statistics = input.required<StatisticsLine>();
    timePeriod = input.required<TimePeriodFilterModel>();
    searchViewOptions = input.required<SearchViewOptionsFilterModel>();

    periodType = PeriodDefinitionType;
    showInformation = false;

    computedTimePeriod = computed(() => {
      let from = null;
        let to = null;
        if (this.timePeriod().useFromToDate) {
            from = this.timePeriod().fromDate;
            to = this.timePeriod().toDate;
        } else {
            from = new Date();
            from.setHours(0, 0, 0, 0);
            from = new Date(from.setMonth(from.getMonth() - this.timePeriod().numberOfMonthsToShow));
            to = new Date();
        }
        return { fromDate: from, toDate: to};
    })
}
